import { gql } from '@apollo/client';

export const FeaturedImageFragment = gql`
  fragment FeaturedImage on NodeWithFeaturedImage {
    featuredImage {
      node {
        id
        sourceUrl
        altText
        mediaDetails {
          width
          height
        }
      }
    }
  }
`;
